import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import type { Test, User } from "@/types";
import { Card } from "@/components/ui/Card";
import { Spinner } from "@/components/ui/Spinner";

export default function AdminDashboard() {
  const [tests, setTests] = useState<Test[]>([]);
  const [students, setStudents] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get<Test[]>("/admin/tests"),
      api.get<User[]>("/admin/students"),
    ])
      .then(([t, s]) => { setTests(t); setStudents(s); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><Spinner size={32} /></div>;
  }

  const totSubs = tests.reduce((acc, t) => acc + (t._count?.submissions ?? 0), 0);

  return (
    <div className="max-w-4xl mx-auto px-4 py-10 space-y-6">
      <header className="flex justify-between items-baseline">
        <h1 className="text-3xl font-serif text-primary">Dashboard</h1>
        <button
          onClick={() => { localStorage.removeItem("jwt"); window.location.href = "/admin"; }}
          className="font-mono text-xs text-secondary hover:text-primary"
        >
          esci →
        </button>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Stat label="Test" value={tests.length} link="/admin/tests" />
        <Stat label="Studenti" value={students.length} link="/admin/studenti" />
        <Stat label="Submission" value={totSubs} />
      </div>

      <Card className="space-y-3">
        <div className="font-mono text-xs uppercase tracking-wider text-secondary">
          Anagrafiche
        </div>
        <div className="flex gap-2 flex-wrap">
          <Link to="/admin/tests" className="bg-accent text-white px-4 py-2 rounded-xl font-mono text-sm hover:brightness-110">
            Test →
          </Link>
          <Link to="/admin/contatti" className="bg-blue text-white px-4 py-2 rounded-xl font-mono text-sm hover:brightness-110">
            Contatti →
          </Link>
          <Link to="/admin/tag" className="bg-purple text-white px-4 py-2 rounded-xl font-mono text-sm hover:brightness-110">
            Tag →
          </Link>
          <Link to="/admin/campagne" className="bg-blue text-white px-4 py-2 rounded-xl font-mono text-sm hover:brightness-110">
            Campagne →
          </Link>
        </div>
        <div className="font-mono text-xs uppercase tracking-wider text-secondary pt-2">
          Sistema
        </div>
        <div className="flex gap-2 flex-wrap">
          <Link to="/admin/whatsapp" className="bg-green text-white px-4 py-2 rounded-xl font-mono text-sm hover:brightness-110">
            WhatsApp setup →
          </Link>
        </div>
      </Card>
    </div>
  );
}

function Stat({ label, value, link }: { label: string; value: number; link?: string }) {
  const inner = (
    <Card className="space-y-1">
      <div className="font-mono text-xs uppercase tracking-wider text-secondary">{label}</div>
      <div className="text-4xl font-mono text-primary">{value}</div>
    </Card>
  );
  return link ? <Link to={link} className="block hover:opacity-90">{inner}</Link> : inner;
}
